module.exports = __webpack_public_path__ + "static/media/43.58901d45.png";